/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type NormalMessageChatReplyPlannerSettingQueryVariables = Exact<{ [key: string]: never; }>;


export type NormalMessageChatReplyPlannerSettingQuery = { normalMessageChatReplyPlannerSetting: { message: string, isEnabled: boolean } | null };


export const NormalMessageChatReplyPlannerSettingDocument = gql`
    query normalMessageChatReplyPlannerSetting {
  normalMessageChatReplyPlannerSetting {
    message
    isEnabled
  }
}
    `;

/**
 * __useNormalMessageChatReplyPlannerSettingQuery__
 *
 * To run a query within a Vue component, call `useNormalMessageChatReplyPlannerSettingQuery` and pass it any options that fit your needs.
 * When your component renders, `useNormalMessageChatReplyPlannerSettingQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useNormalMessageChatReplyPlannerSettingQuery();
 */
export function useNormalMessageChatReplyPlannerSettingQuery(options: VueApolloComposable.UseQueryOptions<NormalMessageChatReplyPlannerSettingQuery, NormalMessageChatReplyPlannerSettingQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<NormalMessageChatReplyPlannerSettingQuery, NormalMessageChatReplyPlannerSettingQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<NormalMessageChatReplyPlannerSettingQuery, NormalMessageChatReplyPlannerSettingQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<NormalMessageChatReplyPlannerSettingQuery, NormalMessageChatReplyPlannerSettingQueryVariables>(NormalMessageChatReplyPlannerSettingDocument, {}, options);
}
export function useNormalMessageChatReplyPlannerSettingLazyQuery(options: VueApolloComposable.UseQueryOptions<NormalMessageChatReplyPlannerSettingQuery, NormalMessageChatReplyPlannerSettingQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<NormalMessageChatReplyPlannerSettingQuery, NormalMessageChatReplyPlannerSettingQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<NormalMessageChatReplyPlannerSettingQuery, NormalMessageChatReplyPlannerSettingQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<NormalMessageChatReplyPlannerSettingQuery, NormalMessageChatReplyPlannerSettingQueryVariables>(NormalMessageChatReplyPlannerSettingDocument, {}, options);
}
export type NormalMessageChatReplyPlannerSettingQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<NormalMessageChatReplyPlannerSettingQuery, NormalMessageChatReplyPlannerSettingQueryVariables>;